import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IDictionaryEntry } from './';
import { InsectaServiceBase } from './insecta.base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService extends InsectaServiceBase {
  public getDictionary(name: string): Observable<IDictionaryEntry[]> {
    return this.get<IDictionaryEntry[]>(`/dictionaries/${name}`, 'v1').pipe(
      map((results) => [...results].sort((a: IDictionaryEntry, b: IDictionaryEntry) => (a.text > b.text ? 1 : -1)))
    );
  }
}
